<template>
  <div class="page-wrapper swiper-slide" :style="`background-image: url(${background});`">
    <slot></slot>
    <img class="down-btn ani animate__infinite" swiper-animate-effect="animate__bounce" src="/static/img/anniversary/down.png" v-if="hasDownBtn" @click="handleButtonClick" />
  </div>
</template>
<script>
export default {
  props: ['background', 'hasDownBtn', 'swiper'],
  methods: {
    handleButtonClick () {
      this.swiper.slideNext()
    }
  }
}
</script>
<style lang="less" scoped>
.page-wrapper {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  background-size: cover;

  .down-btn {
    z-index: 99;
    position: absolute;
    bottom: 6.4vw;
    left: 50vw;
    margin-left: -4vw;
    width: 8vw;
    height: 8vw;
  }
}
</style>


// WEBPACK FOOTER //
// PageWrapper.vue?ffdfd466